$(document).ready(function() {
	var socials = $('.socials-icon').html();
	$('.top-socials').html(socials);
	$('#shopify-section-1587978572395,#shopify-section-1587978714486,#shopify-section-1587978665867').addClass('index-collection');


	$('.plus').click(function () {
		if ($(this).prev().val() < 99) {
			$(this).prev().val(+$(this).prev().val() + 1);
		}
	});
	$('.minus').click(function () {
		if ($(this).next().val() > 1) {
			if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
	});
	$('a[href="https://www.midlandautocare.co.uk/"]').attr('target','_blank');
});